import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { timer, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { ToastrService } from 'ngx-toastr';
import { UserRegistrationService } from '../../services/user-registration.service';
import { SmsResponse } from '../../models/sms-response.model';
import { ForgotPasswordConstant } from '../../constants/forgot-password.constant';
import { ForgotPasswordValid } from '../../models/forgot-password-valid.model';
import { SharedUrls } from '../../../shared/constants/shared.constants';
import { FormatTimePipe } from "../../Pipes/format-time.pipe";
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-user-otp',
  templateUrl: './user-otp.component.html',
  styleUrls: ['./user-otp.component.scss'],
  standalone: false
})
export class UserOtpComponent implements OnInit {

  otpReSent = false;
  profileForm = new FormGroup({
    otp: new FormControl('', Validators.compose([Validators.required,
    Validators.minLength(6), Validators.maxLength(6)])),
  });
  hasResend = false;
  tick = 1000;
  countDown!: Subscription;
  counter!: number;
  otpResendAttempts!: number;
  constructor(private service: UserRegistrationService, private route: Router,
    private toastrService: ToastrService,
    private translocoService: TranslocoService,) { }
  @Input() id!: string;
  @Input() mobileNo!: string;
  @Input() showSpinner!: boolean;
  @Input() showError!: boolean;
  @Input() otpWaitingInMinutes!: number;
  @Input() isOnlinePay!: boolean;
  @Input() forgotpass!: boolean;
  @Input() maxOtpResendAttempts!: number;
  @Output() submit: EventEmitter<any> = new EventEmitter();
  private _unsuccessfullAttempt!: number;

  get unsuccessfullAttempt(): number {
    return this._unsuccessfullAttempt;
  }

  @Input('unsuccessfullAttempt') set unsuccessfullAttempt(v: number) {
    this._unsuccessfullAttempt = v;

    if (this.unsuccessfullAttempt > 2 && !this.forgotpass) {
      this.hasResend = true;
    }

    if ((this.unsuccessfullAttempt === 3 || this.unsuccessfullAttempt === 6 || this.unsuccessfullAttempt === 9) && this.forgotpass) {
      this.hasResend = true;

    } else if (this.unsuccessfullAttempt === 12 && this.forgotpass) {
      this.forgotPasswordMaxOtp();
    }
  }

  ngOnInit() {
    this.startTimer(this.otpWaitingInMinutes, true);
  }

  private startTimer(countDownInMin: number, showResend: boolean) {
    this.counter = countDownInMin * 60;
    this.countDown = timer(0, this.tick).subscribe(() => {

      if (this.counter === 0 && !this.forgotpass && (this.unsuccessfullAttempt === 2 || this.unsuccessfullAttempt === 0)) {
        this.hasResend = true;
        this.counter = countDownInMin * 60;
      }

      if (this.counter === 0 && this.otpResendAttempts !== 0 && this.unsuccessfullAttempt !== 11
        && this.unsuccessfullAttempt <= 12 && this.forgotpass) {
        this.hasResend = true;
        this.counter = countDownInMin * 60;
      }

      if (this.counter) {
        --this.counter;
      } else {
        if (!this.forgotpass) {
          this.countDown.unsubscribe();
          this.hasResend = showResend;
          if (!showResend) {
            this.route.navigate(['amghara/paylink-expired']);
          }
        }

        if (this.counter === 0 && this.forgotpass && (this.unsuccessfullAttempt === 11 || this.otpResendAttempts === 0)) {
          this.countDown.unsubscribe();
          this.forgotPasswordMaxOtp();
        }
      }
    });
  }

  verify() {
    if (this.profileForm.valid) {
      this.submit.emit(this.profileForm.value);
    }
  }

  resendOtp() {
    this.profileForm.reset();
    this.service.resendOtp(this.id).subscribe((response: SmsResponse) => {
      this.otpReSent = true;
      this.hasResend = false;
      this.otpResendAttempts = response.otpResendAttempts;

      this.countDown.unsubscribe();
      this.startTimer(response.otpWaitingInMinutes, response.otpResendAttempts > 0);
    });
  }

  forgotPasswordMaxOtp() {
    let attemptDate = new Date();
    attemptDate.setMinutes(attemptDate.getMinutes() + 30);

    localStorage.setItem(
      ForgotPasswordConstant.ForgotPasswordValid,
      JSON.stringify({
        count: 0,
        attemptDate: null,
        restrictDate: attemptDate
      } as unknown as ForgotPasswordValid)
    );
    this.toastrService.error(this.translocoService.translate('challenge.ForgotPasswordMaxOtpReached'));
    this.route.navigate([SharedUrls.Login]);
  }
}
